import { COMMERCIAL_SITE } from '@connexio/shared/constants';

/** mailto for the company inbox, or the enquiry form on this page when none is configured. */
export function marketingContactHref(): string {
  return COMMERCIAL_SITE.contactEmail ? `mailto:${COMMERCIAL_SITE.contactEmail}` : '#enterprise';
}
